export const RealityCheckMessageChannels = {
    GetSettings: "GetSettings",
    SaveSettings: "SaveSettings",
    GetWageringInformation: "GetWageringInformation"
};
//# sourceMappingURL=index.js.map